<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <div class="inputs-wrapper">
          <h3>Prodajno mjesto:</h3>
          <md-radio v-model="kind" value="offline">Blagajna (ukupno)</md-radio>
          <md-radio v-model="kind" value="offline-tickets">Blagajna (Prodaja karata)</md-radio>
          <md-radio v-model="kind" value="online">Web</md-radio>
          <md-radio v-model="kind" value="coupon">Kuponi</md-radio>
          <md-radio v-model="kind" value="sightseeing-secret-history">RK/TPK</md-radio>
        </div>
        <div class="inputs-wrapper">
          <h3>Period:</h3>
          <md-datepicker v-model="period.from" md-immediately>
            <label>Od</label>
          </md-datepicker>
          <md-datepicker v-model="period.to" md-immediately>
            <label>Do</label>
          </md-datepicker>
        </div>
        <div class="inputs-wrapper with-button">
          <md-button class="md-raised md-dense md-primary" v-on:click="showReport">
            Traži
          </md-button>
        </div>
      </div>
      <div ref="reports">
        <h2 class="md-title">
          Blagajnički izvještaj ({{ reportKinds[kind] }})
          <span class="lighter" v-if="searched">
            {{ new Date(period.from).toLocaleDateString('hr-HR') }}
            -
            {{ new Date(period.to).toLocaleDateString('hr-HR') }}
          </span>
        </h2>
        <div v-for="performance in $store.state.receivedData.reportsCashRegister.list.performances" class="single-table cash-register-play">
          <h2 class="md-title">{{ performance.title }} - {{ getPlayDate(performance.start_time).date }} - {{ getPlayDate(performance.start_time).time }}</h2>
          <md-table class="print-table small-table">
            <md-table-row>
              <md-table-head class="t-align-left">Kategorija sjedala</md-table-head>
              <md-table-head class="t-align-right">Količina</md-table-head>
              <md-table-head class="t-align-right">Iznos</md-table-head>
            </md-table-row>
            <md-table-row v-for="category, key in performance.seat_category.amount" v-if="key !== 'sum'">
              <md-table-cell class="t-align-left">
                {{ $store.state.kindsMapper[key] }}
              </md-table-cell>
              <md-table-cell class="t-align-right">{{ performance.seat_category.count[key] }}</md-table-cell>
              <md-table-cell class="t-align-right">{{ formatCurrency(category) }}</md-table-cell>
            </md-table-row>
            <md-table-row class="last-row">
              <md-table-cell><strong>Ukupno</strong></md-table-cell>
              <md-table-cell class="t-align-right">{{ performance.seat_category.count.sum }}</md-table-cell>
              <md-table-cell class="t-align-right">{{ formatCurrency(performance.seat_category.amount.sum) }}</md-table-cell>
            </md-table-row>
          </md-table>

          <md-table class="print-table small-table">
            <md-table-row>
              <md-table-head class="t-align-left">Način plaćanja</md-table-head>
              <md-table-head class="t-align-right">Količina</md-table-head>
              <md-table-head class="t-align-right">Iznos</md-table-head>
            </md-table-row>
            <md-table-row v-for="payment, key in performance.payment_type.amount" v-if="key !== 'sum' && !(key.toString() == 'null' && performance.payment_type.count[key] === 0)">
              <md-table-cell class="t-align-left">
                <span v-if="key == 'cash'">Gotovina</span>
                <span v-else-if="key == 'coupon'">Darovni bon</span>
                <span v-else class="capitalize">{{ key }}</span>
              </md-table-cell>
              <md-table-cell class="t-align-right">{{ performance.payment_type.count[key] }}</md-table-cell>
              <md-table-cell class="t-align-right">{{ formatCurrency(payment) }}</md-table-cell>
            </md-table-row>
            <md-table-row class="last-row">
              <md-table-cell><strong>Ukupno</strong></md-table-cell>
              <md-table-cell class="t-align-right">{{ performance.payment_type.count.sum }}</md-table-cell>
              <md-table-cell class="t-align-right">{{ formatCurrency(performance.payment_type.amount.sum) }}</md-table-cell>
            </md-table-row>
          </md-table>
          <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.reports)">
            Ispiši
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPlay',
  mixins: [FormatCurrency, ReportsMixin('getReportsCashRegister')],
  data(){
    return{
      kind: 'offline',
      reportKinds:{
        'offline': 'Blagajna (ukupno)',
        'offline-tickets': 'Blagajna (Prodaja karata)',
        'online': 'Web',
        'coupon': 'Kuponi',
        'sightseeing-secret-history': 'RK/TPK',
      }
    }
  },

  methods:{
    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getPlayDate(data){
      let date = new Date(data);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    },

    async showReport(){
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {
        kind: this.kind,
        from: this.period.from.toLocaleDateString('hr-HR'),
        to: this.period.to.toLocaleDateString('hr-HR'),
      }
      await this.$store.dispatch('getReportsCashRegister', filter)
      this.$store.state.pageLoaded = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .single-table{
    h2{
      margin: 80px 0 40px;
      text-align: left;
      padding-left: 24px;
    }
  }

  .reports-listing{
    padding-bottom: 80px;
    .md-table{
      & + .md-table{
        margin-top: 50px;
      }
    }
  }

  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsCashRegisterPlay.vue